<template>
    <div>
        <el-dialog
            title="预警设置"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="600px">
            <div class="formContent">
                <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="120px">
                    <el-form-item label="预警方式" prop="alertType">
                        <el-select v-model="form.alertType" placeholder="请选择" @change='typeChange'>
                            <el-option v-for="item in warningTypeDic"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="预警阈值" prop="alertValue" v-if="form.alertType == 1">
                        <jd-input-price v-model="form.alertValue" style="width:240px;padding: 0" maxlength="10"></jd-input-price>
                    </el-form-item>
                    <el-form-item label="可用天数" prop="alertValue" v-if="form.alertType == 2">
                        <el-input style="width:240px" maxlength="6" v-model="form.alertValue" @input="form.alertValue=form.alertValue.replace(/^(0+)|[^\d]+/g,'')"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import util from '@/utils/util'
    export default {
        data() {
            return {
                util,
                dialogVisible: false,
                id: '',
                form: {
                    "alertType": "",
                    "alertValue": "",
                },
                rules:{
                    alertType: [{required: true, message:'请选择预警类型', trigger: 'blur'}],
                    alertValue: [{required: true, message:'请输入预警阈值', trigger: 'change'}]
                },
                warningTypeDic: [
                    {
                        label: '余额预警',
                        value: 1
                    },
                    {
                        label: '可用天数预警',
                        value: 2
                    }
                ]
            };
        },
        watch:{
            dialogVisible (val) {
                if(this.$refs['form'] && !val){
                    this.$refs['form'].resetFields()
                }
            },
        },
        methods:{
            typeChange () {
                this.form.alertValue = ''
            },
            submit () {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        if(this.form.alertValue < 0) {
                            this.$message.error('预警阈值不得小于0')
                            return 
                        }
                        this.$confirm('是否确认提交？','温馨提示')
                        .then(_=>{
                            let reqData = {
                                alertType: this.form.alertType,
                                alertValue: this.form.alertType == 1 ? (this.form.alertValue * 100).toFixed(0) : this.form.alertValue,
                                id: this.id,
                            }
                            this.$Axios._post({
                                url: this.$Config.apiUrl.setAmmeterAlert,
                                params: { 
                                    ...reqData
                                }
                            }).then(res => {
                                this.$message.success('操作成功')
                                this.dialogVisible = false
                                this.$emit('change')
                            })
                        })
                        .catch(_=>{})
                        
                    }
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    .content{
        background: #F2F6FC99;
        border-radius: 4px;
        padding: 10px;
        margin-bottom: 10px;
    }
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
</style>